import type { LucideIcon } from 'lucide-react';
import { cn } from '@/shared/lib/cn';

type IconTileProps = {
  readonly icon: LucideIcon;
  readonly className?: string;
};

export function IconTile({ icon: Icon, className }: IconTileProps) {
  return (
    <span
      className={cn(
        'flex size-9 shrink-0 items-center justify-center rounded-lg bg-secondary text-secondary-foreground',
        className,
      )}
    >
      <Icon className="size-4.5" />
    </span>
  );
}
